<template>
  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">
      <!-- <LoaderSwiper /> -->
      <div class="swiper Swiper SwiperCards" :class="entranceClassList" :data-swiper-id="parentId">
        <div class="swiper-wrapper Swiper__wrapper" :class="teaserEditView">
          <div v-for="newsTeaserItem in NewsTeaser" class="swiper-slide Swiper__wrapper__slide">
            <div class="etx-card Card has-shadow has-hover" :class="entranceClassList">
              <a class="etx-card__link Card__link" :href="newsTeaserItem.url?.path" :title="newsTeaserItem.title"></a>
              <div class="etx-card__item Card__item ph-0 pv-0">
                <div class="etx-media Media">
                  <MediaImage :media="newsTeaserItem?.image" imageStyle="image_3_2" />
                </div>
              </div>
              <div class="etx-card__item Card__item pb-0 grow-1">
                <div v-if="newsTeaserItem.tags" class="TagList" :class="entranceClassList">
                  <div v-for="tag in newsTeaserItem.tags" :key="tag.name" class="Tag">
                    {{ tag.name }}
                  </div>
                </div>
              </div>
              <div class="etx-card__item Card__item pt-200 pb-150 grow-1">
                <div class="etx-text Text">
                  <p class="font-size-smaller font-color-medium">{{ newsTeaserItem.readingduration }}</p>
                  <p class="font-size-larger">
                    <span class="font-weight-bold">{{ newsTeaserItem.title }}</span><br>
                    <span class="font-color-medium">{{ newsTeaserItem.subtitle }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Swiper__controls">
          <div class="swiper-pagination Swiper__controls__pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts" setup>

const props = defineProps<{
  parentId: string
  NewsTeaser: Array<{
    nid: string
    uuid: string
    title?: string
    subtitle?: string
    lead?: string
    sublead?: string
    readingduration?: string
    publication?: string
    depublication?: string
    visibledate?: Object
    tags?: Array<Object>
    location?: Array<Object>
    image?: Object
    url?: Array<Object>
  }>
}>()

const newsTeaserIds: string[] = (props.NewsTeaser || []).map((newsTeaserItem) => newsTeaserItem.uuid);
const queryKey = `newsTeaserItems-${newsTeaserIds.join('-')}`;


const variables = {
  exclude: [props.parentId],
  limit: 8,
};

const { data: NewsTeaser = [] } = await useAsyncData(queryKey, async () => {
  return await useGraphqlQuery('NewsTeaser', variables).then((v) => {
    return v.data?.entityQuery?.items ?? [];
  });
});

const { options, isEditing } = defineBlokkli({
  bundle: 'news_teaser_automatically',
  globalOptions: ['spacingTop', 'spacingBottom'],
});

const paragraphClassList = computed(() => {
  const classList = [];

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop);
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom);
  }

  return classList;
});

const entranceClassList = computed(() => {
  const classList = [];
  if (!isEditing) {
    classList.push('will-appear', 'move-up');
  }
  return classList;
});


const teaserEditView = computed(() => {
  return isEditing ? 'teaserEditMode' : '';
});

</script>

<style>
.teaserEditMode {
  max-width: 34%
}
</style>